module.exports = {
	"id": "LA",
	"name": "Lao",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": 0.001654,
			"10": 0.003308,
			"11": 0.089316,
			"12": 0.011578,
			"13": 0.001654,
			"14": null,
			"15": 0.004962,
			"16": 0.003308,
			"17": null,
			"18": 0.003308,
			"19": 0.003308,
			"20": 0.014886,
			"21": 0.001654,
			"22": 0.001654,
			"23": 0.003308,
			"24": null,
			"25": 0.003308,
			"26": 0.004962,
			"27": 0.004962,
			"28": 0.004962,
			"29": 0.006616,
			"30": 0.004962,
			"31": 0.02481,
			"32": 0.004962,
			"33": 0.062852,
			"34": 0.004962,
			"35": 0.006616,
			"36": 0.006616,
			"37": 0.003308,
			"38": 0.028118,
			"39": 0.009924,
			"40": 0.018194,
			"41": 0.004962,
			"42": 0.006616,
			"43": 1.658962,
			"44": 0.014886,
			"45": 0.046312,
			"46": 0.01654,
			"47": 0.026464,
			"48": 0.018194,
			"49": 0.11578,
			"50": 0.039696,
			"51": 0.10751,
			"52": 0.133974,
			"53": 3.73804,
			"54": 1.076754,
			"55": 0.039696,
			"56": 0.014886,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.003308,
			"4": 0.003308,
			"5": null,
			"6": 0.003308,
			"7": 0.003308,
			"8": null,
			"9": 0.003308,
			"10": 0.004962,
			"11": 0.003308,
			"12": 0.006616,
			"13": 0.01654,
			"14": 0.003308,
			"15": 0.003308,
			"16": 0.003308,
			"17": 0.001654,
			"18": 0.004962,
			"19": null,
			"20": 0.003308,
			"21": 0.003308,
			"22": 0.004962,
			"23": 0.004962,
			"24": 0.001654,
			"25": 0.004962,
			"26": 0.009924,
			"27": null,
			"28": 0.003308,
			"29": 0.00827,
			"30": 0.014886,
			"31": 0.003308,
			"32": 0.003308,
			"33": 0.004962,
			"34": 0.006616,
			"35": 0.043004,
			"36": 0.004962,
			"37": 0.011578,
			"38": 0.011578,
			"39": 0.013232,
			"40": 0.018194,
			"41": 0.006616,
			"42": 0.014886,
			"43": 0.044658,
			"44": 0.038042,
			"45": 0.031426,
			"46": 0.019848,
			"47": 0.191864,
			"48": 0.213366,
			"49": 1.237192,
			"50": 0.17367,
			"51": 0.001654,
			"52": null,
			"3.5": null,
			"3.6": 0.004962
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.003308,
			"29": 0.004962,
			"30": 0.003308,
			"31": null,
			"32": 0.003308,
			"33": null,
			"34": 0.018194,
			"35": 0.004962,
			"36": 0.003308,
			"37": 0.138936,
			"38": 0.004962,
			"39": 0.003308,
			"40": 0.056236,
			"41": 0.014886,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": 0.003308,
			"7": 0.004962,
			"8": 0.018194,
			"9": 0.038042,
			"10": 0.092624,
			"3.1": null,
			"3.2": null,
			"5.1": 0.018194,
			"6.1": null,
			"7.1": null,
			"9.1": 0.071122
		},
		"ios_saf": {
			"8": 0,
			"10": 13.1450125429,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.354242877602,
			"8.1-8.4": 0.654448706078,
			"9.0-9.2": 0.312214061615,
			"9.3": 4.76326581182
		},
		"android": {
			"3": 0,
			"4": 0.159716992248,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.019964624031,
			"4.1": 0.576122007752,
			"4.2-4.3": 1.44030501938,
			"4.4": 3.30271923256,
			"4.4.3-4.4.4": 3.33124012403
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.14140046,
			"9": 0.04940498,
			"10": 0.03577602,
			"11": 0.45486654,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0938166446508,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00260601790697
		},
		"edge": {
			"12": 0.026464,
			"13": 0.06616,
			"14": 0.061198
		},
		"ie_mob": {
			"10": 0.278121633803,
			"11": 1.1323523662
		},
		"bb": {
			"7": 0,
			"10": null
		},
		"samsung": {
			"0": 11.492442
		},
		"and_uc": {
			"0": 0.87633
		},
		"op_mini": {
			"0": 1.26397533744
		},
		"and_chr": {
			"0": 45.240368
		},
		"and_ff": {
			"0": 0.033384
		}
	},
	"total": 99.440322
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/LA.json
 ** module id = 571
 ** module chunks = 0
 **/